import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const sections = [
  {
    title: "1. Responsable du traitement",
    content: (
      <p>Le responsable du traitement des données est SOMINKA, représenté par Amelia Anna Sominka (SIRET : 101 634 145 00011), 4 Rue Judaïque, 33000 Bordeaux, France.</p>
    ),
  },
  {
    title: "2. Données collectées",
    content: (
      <>
        <p className="mb-3">Ce site peut collecter les données personnelles suivantes via le formulaire de contact :</p>
        <ul className="list-disc pl-5 space-y-1 text-sm text-gray-600">
          <li>Nom et prénom</li>
          <li>Adresse email</li>
          <li>Numéro de téléphone</li>
          <li>Message / description de la demande</li>
        </ul>
      </>
    ),
  },
  {
    title: "3. Finalité du traitement",
    content: (
      <p>Ces données sont collectées et utilisées uniquement pour répondre aux demandes de contact et de conseil formulées par les visiteurs du site. Elles ne sont pas utilisées à des fins commerciales ou publicitaires.</p>
    ),
  },
  {
    title: "4. Partage des données",
    content: (
      <p>Les données personnelles collectées ne sont ni vendues, ni louées, ni partagées avec des tiers. Elles restent strictement confidentielles et sont utilisées uniquement en interne pour répondre aux demandes reçues.</p>
    ),
  },
  {
    title: "5. Conservation des données",
    content: (
      <p>Les données sont conservées pour la durée nécessaire au traitement de la demande, dans le respect des obligations légales applicables au droit français.</p>
    ),
  },
  {
    title: "6. Vos droits",
    content: (
      <>
        <p className="mb-3">Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :</p>
        <ul className="list-disc pl-5 space-y-1 text-sm text-gray-600 mb-4">
          <li>Droit d'accès à vos données</li>
          <li>Droit de rectification des données inexactes</li>
          <li>Droit à l'effacement de vos données</li>
          <li>Droit à la portabilité de vos données</li>
        </ul>
        <p>
          Pour exercer ces droits, contactez-nous :{' '}
          <a href="mailto:ameliasominkaaa@outlook.com" className="text-[#1A2B4A] hover:underline">
            ameliasominkaaa@outlook.com
          </a>
        </p>
      </>
    ),
  },
  {
    title: "7. Cookies",
    content: (
      <p>Ce site n'utilise pas de cookies à des fins publicitaires ou de traçage. Des cookies techniques peuvent être utilisés pour assurer le bon fonctionnement du site.</p>
    ),
  },
];

export default function Privacy() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1 pt-20">
        <section className="py-16 bg-white border-t-4 border-[#1A2B4A]">
          <div className="max-w-3xl mx-auto px-6 text-center">
            <h1 className="font-poppins text-4xl font-semibold text-[#1A2B4A] mb-3">
              Politique de confidentialité
            </h1>
            <p className="text-gray-500 text-sm">Dernière mise à jour : mars 2026</p>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="max-w-3xl mx-auto px-6 lg:px-8">
            <div className="space-y-10">
              {sections.map((section, i) => (
                <div key={i}>
                  <h2 className="font-poppins text-xl font-semibold text-[#1A2B4A] mb-4">
                    {section.title}
                  </h2>
                  <div className="text-gray-600 text-sm leading-relaxed">
                    {section.content}
                  </div>
                  {i < sections.length - 1 && (
                    <div className="border-b border-gray-100 mt-10"></div>
                  )}
                </div>
              ))}
            </div>

            <div className="mt-12 pt-8 border-t border-gray-100">
              <Link
                to="/"
                className="text-sm text-[#1A2B4A] hover:underline cursor-pointer"
              >
                ← Retour à l'accueil
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
